module.exports = __webpack_public_path__ + "static/media/logo_white.8a331351.png";